import { Phone, Mail, ArrowUp, Siren, MapPin } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { label: "Početna", href: "#pocetna" },
  { label: "Usluge", href: "#usluge" },
  { label: "Šlep Služba", href: "#slep-sluzba" },
  { label: "Proizvodi", href: "#proizvodi" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.07] bg-[#0c0c0f] px-6 lg:px-12 pt-16 pb-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-white/[0.07]">
          <div>
            <a data-testid="footer-logo" href="#pocetna" className="flex items-center gap-3">
              <Logo size={44} />
              <span className="font-display text-3xl tracking-wider text-white">
                AUTO<span className="text-red-500">BAY</span>
              </span>
            </a>
            <p className="text-sm text-zinc-500 leading-relaxed mt-5 max-w-xs">
              Vaš najpouzdaniji partner za auto servis i šlep službu širom Srbije.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 bg-red-600/10 border border-red-600/25 text-red-400 text-xs font-bold tracking-wider uppercase px-4 py-2 rounded-full">
              <Siren size={13} /> Hitna pomoć 24/7
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400 mb-5">Navigacija</h4>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-zinc-500 hover:text-white transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400 mb-5">Kontakt</h4>
            <div className="space-y-4">
              <a data-testid="footer-phone-link" href="tel:0677775613" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-white transition-colors">
                <Phone size={15} className="text-red-500" /> 067 777 5613
              </a>
              <a href="mailto:autobayserbia@gmail.com" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-white transition-colors">
                <Mail size={15} className="text-red-500" /> autobayserbia@gmail.com
              </a>
              <a data-testid="footer-address-link" href="https://www.google.com/maps?q=Milo%C5%A1a+Obili%C4%87a+20,+%C4%8Cekmin,+Srbija" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-white transition-colors">
                <MapPin size={15} className="text-red-500" /> Miloša Obilića 20, Čekmin
              </a>
              <p className="text-xs text-zinc-600 leading-relaxed">
                Servis: Pon - Sub 08:00 - 19:00<br />Šlep služba: 00 - 24h, svakog dana
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">© 2026 AutoBay Serbia. Sva prava zadržana.</p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-zinc-500 hover:text-red-400 transition-colors"
          >
            Nazad na vrh <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
